import {useAppSelector} from "./store";

export function useCustomBehavior() {
    const theme = useAppSelector((state) => state.assemblyEditorSlice.theme);

    const getOrCreateSessionId = () => {
        const existingSessionId = sessionStorage.getItem('sudSessionId');
        if (existingSessionId) return existingSessionId;

        const newSessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem('sudSessionId', newSessionId);
        return newSessionId;
    };

    const openReactAppHistoryInNewTab = () => {
        const currentOrganization = theme.team;
        const urlToOpen =  process.env.REACT_APP_HISTORY_REDIRECTION.replace('{orgaSubDomain}', currentOrganization);

        // Mark the action with metadata so StartupList can ignore stale/foreign redirects.
        const sessionId = getOrCreateSessionId();
        localStorage.setItem('actionTimestamp', String(Date.now()));
        localStorage.setItem('actionSessionId', sessionId);

        if(urlToOpen === undefined){
            console.error('No url to open');
            return;
        }
        window.open(urlToOpen, '_blank');
    }


    return {
        openReactAppHistoryInNewTab
    };
}